module.exports = __webpack_public_path__ + "img/heart.b1fda977.svg";